import { FetchStatus } from "../globalConsts";

const { Uninitialized, FetchingInitial, Refetching, Fetched, Failed } =
  FetchStatus;

export const isUninitialized = (status: FetchStatus) =>
  status === Uninitialized;
export const isFetchingInitial = (status: FetchStatus) =>
  status === FetchingInitial;
export const isRefetching = (status: FetchStatus) => status === Refetching;
export const isFetched = (status: FetchStatus) => status === Fetched;
export const isFailed = (status: FetchStatus) => status === Failed;

export const isFetching = (s: FetchStatus) =>
  isFetchingInitial(s) || isRefetching(s);

export const isLoading = (s: FetchStatus) =>
  isUninitialized(s) || isFetching(s);

export const isInitialLoadComplete = (s: FetchStatus) =>
  !(isUninitialized(s) || isFetchingInitial(s) || isFailed(s));
